/* eslint-disable import/no-anonymous-default-export */
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import thunkMiddleware from "redux-thunk";
import { persistStore } from "redux-persist";
import { BUILD_ENV } from "@constants/build-env";
import rootReducer from "@store/slices";
import { AUTH_RESET } from "./action-types";

// Note: rootReducer already has persist reducers for entities, features, and admin
// No need to wrap it again - that would cause double persistence
const reducer = combineReducers({
  root: rootReducer,
});

const middlewares = [thunkMiddleware];

// purpose of appReduce is to reset redux store
// once AUTH_RESET action is dispatched
const appReducer = (state: TObject, action: TObject) => {
  if (action.type === AUTH_RESET) {
    state = undefined;
  }

  return reducer(state, action);
};

export const store = configureStore({
  reducer: appReducer,
  preloadedState: {},
  middleware: middlewares,
  devTools: process.env.REACT_APP_ENV !== BUILD_ENV.PRODUCTION,
});

// @ts-ignore
if (window?.Cypress) {
  // @ts-ignore
  window.store = store;
}

export type ReduxState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default () => {
  const persistor = persistStore(store);
  return { store, persistor };
};
